<template>
  <div class="input-container" :class="classes">
    <div class="flex justify-between items-center">
      
      <span v-if="label" class="flex items-center mb-2">
        <label :class="labelClass">{{ label }}</label>
        <template v-if="hasTooltip">
          <UIcon
            :id="tooltipId"
            name="i-pkg-alert-info-fill"
            class="size-4 shrink-0 text-[#141414] cursor-help"
            :style="tooltipCustomStyle"
          />
          <b-tooltip triggers="hover" :target="tooltipId" custom-class="input-tooltip-class">
            {{ tooltipText }}
          </b-tooltip>
        </template>
      </span>

      <CharCounter default-classes="text-base leading-5 font-medium mr-3 mb-2 font-manrope" v-if="charCounter" ref="charCounter" :max="max" :count="count" />
    </div>
    <label class="input-body mb-0" :id="bodyId" :for="inputFieldId" :style="bodyStyles" :class="bodyClass">
      <slot name="container"></slot>
    </label>
    <div class="input-assistive" :class="{ 'hidden': !assistive, 'input-assistive-none': noAssistive }">
      <span class="font-manrope text-sm leading-5 font-normal">{{ assistive }}</span>
    </div>
  </div>
</template>

<script>
import CharCounter from '../CharCounter.vue';

export default {
  components: {
    CharCounter,
  },
  computed: {
    tooltipId() {
      return `tooltip-id-${Math.random()}`
    },
    hasTooltip() {
      return this.tooltipText.length
    },
  },
  props: {
    tooltipCustomStyle: {
      type: Object,
      default: () => ({})
    },
    tooltipText: {
      type: String,
      default: '',
    },
    inputFieldId: {
      type: String,
      default: `input-field-id-${Math.random()}`
    },
    bodyClass: {
      type: String,
      default: ''
    },
    bodyId: {
      type: String,
      default: '',
    },
    noAssistive: {
      type: Boolean,
      default: false,
    },
    label: {
      type: [String, Boolean],
      default: false,
    },
    labelClass: {
      type: String,
      default: 'font-manrope font-normal text-base leading-5 m-0 tracking-[-0.3px] text-[#212529]',
    },
    assistive: {
      type: [String, Boolean],
      default: false,
    },
    max: {
      type: [String, Number],
      default: 120,
    },
    count: {
      type: [String, Number],
      default: 0,
    },
    charCounter: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: 'pb-4',
    },
    bodyStyles: {
      type: [String, Object],
      default: '',
    },
  },
};
</script>
